import React from 'react';
import { Check } from 'lucide-react';

const ServiceBenefits = ({ title, subtitle, benefits, footerText }) => {
    const defaultBenefits = [
        "Improved design decision making",
        "More accurate as-built representation",
        "Improved coordination between trades",
        "Decreased chance of site errors and clashes",
        "Easier remodeling and retrofitting",
        "Improved documentation to obtain necessary approvals and to support the execution of the project",
        "More effective facility management and maintenance planning"
    ];

    const displayBenefits = benefits || defaultBenefits;

    return (
        <section className="service-benefits-section">
            <div className="service-benefits-container">
                <div className="service-benefits-header">
                    <h2 className="service-benefits-title">
                        {title || (
                            <>
                                <span className="text-primary">Benefits of Scan to</span> BIM for California Projects
                            </>
                        )}
                    </h2>
                    <p className="service-benefits-subtitle">
                        {subtitle || "California construction and remodeling projects take advantage of speed, regulatory compliance, coordination between disciplines, and precision. This is why scanning to BIM is a popular current workflow for many of today's AEC teams."}
                    </p>
                </div>

                <div className="benefits-box">
                    <ul className="benefits-list-simple">
                        {displayBenefits.map((benefit, index) => (
                            <li key={index} className="benefit-item-simple">
                                <div className="check-icon-wrapper">
                                    <Check size={20} color="#54b248" strokeWidth={4.5} />
                                </div>
                                <span className="benefit-text-simple">{benefit}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <p className="service-benefits-footer">
                    {footerText || "Scan to BIM can provide your team with the ability to work faster and smarter than ever before through the conversion of real life site conditions into actionable BIM data."}
                </p>
            </div>
        </section>
    );
};

export default ServiceBenefits;
